import { t } from "i18next";
import { Button, Col, Row } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import Select from "react-select";

import { nanoid } from "nanoid";
import { IAllStates } from "../../../../store/rootReducer";
import { ContentWorkflowService } from "../../../contentWorkflow/service";
import { ErrorToast } from "../../../../shared/toasters/toasters";
import contentWorkflowSlice from "../../../../store/contentWorkflow/contentWorkflowSlice";

export const Stepper = ({ step }: any) => {
  //   const { accessRights, roles } = useSelector(
  //     (state: IAllStates) => state.auth
  //   );
  //   const userClientDashboard = accessRights?.includes(
  //     "client_dashboard_can_view"
  //   );
  const allTabs = ["ALL", "BASE_DATA", "ATTRIBUTE", "CONTENT", "MEDIA"];
  //   const isManager = roles?.includes("ROLE_MANAGER");
  //   const isAdmin = roles?.includes("ROLE_ADMIN");
  //   const isCompanyAdmin = roles?.includes("ROLE_COMPANY_ADMIN");

  const [tabsList, setTabsList] = useState(allTabs);

  const handleStepSteper = (
    status: string
    //  id: number
  ) => {
    switch (status) {
      //   case "SETTING_UP":
      //     return `/app/content-workflow/setting-up/${id}`;
      case "ALL":
        return `/app/products/manage/step-all`;
      case "BASE_DATA":
        return `/app/products/manage/step-base`;
      case "ATTRIBUTE":
        return `/app/products/manage/step-attribute`;
      case "CONTENT":
        return `/app/products/manage/step-content`;
      case "MEDIA":
        return `/app/products/manage/step-media`;

      default:
        return `/app/products/manage`;
    }
  };
  //   const accessUserClientDashboard = () => {
  //     if (userClientDashboard && !isAdmin && !isCompanyAdmin && !isManager) {
  //       return false;
  //     } else {
  //       return true;
  //     }
  //   };

  return (
    <Row>
      <Col md={12}>
        <ul className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-3">
          {tabsList?.map((stepName: string) => {
            return (
              <li className="nav-item" key={stepName}>
                <Link
                  className={`nav-link ${step === stepName ? "active" : ""}`}
                  to={handleStepSteper(
                    stepName
                    // Number(id)
                  )}
                >
                  {t(`manage.${stepName}`)}
                </Link>
              </li>
            );
          })}
        </ul>
      </Col>
    </Row>
  );
};
